import { useState } from 'react';
import { styled } from '@mui/material/styles';
import {
    TableCell, tableCellClasses, TableRow, Typography, Divider, TableContainer, Paper, Table, TableHead, TableBody, Button, Card, CardActions, CardContent, CardHeader,
    Collapse, Grid, IconButton, Stack, IconButtonProps
} from '@mui/material';
import { Box } from '@mui/system';
import { format } from 'date-fns';
import { observer } from 'mobx-react-lite';
import { useEffectOnce, useMediaQuery } from 'usehooks-ts';
import GenerateReportHeading from '../../../app/common/reportsHeading/GenerateReportHeading';
import { withNavbar } from '../../../app/layout/HOC';
import SkeltonAnimation from '../../../app/layout/SkeltonAnimation';
import { useStore } from '../../../app/stores/store';
import { koReportingContainerStyles } from '../../basicUser/koreporting/reports/koReportingContainerStyles';
import { TempRegisterUser } from '../../../app/models/admin';
import AdminTempUserActionModal from './AdminTempUserActionModal';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { mainStyles } from '../../mainStyles';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';


const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#fcfcfc',
        fontSize: 16,
        fontWeight: 300,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontWeight: 300,
        fontStrethed: 'expanded',
    },
}));
const StyledTableRow = styled(TableRow)(() => ({

    '&:nth-of-type(odd)': {
        backgroundColor: '#DAE5F1',
    },
    '&:nth-of-type(even)': {
        backgroundColor: '#fcfcfc',
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const gridContainer = {
    xs: 1,
    sm: 2,
    md: 3
} as const;
const textGen = (title: string, value: string, xs: number, sm: number) => {
    return <Grid item xs={xs} sm={sm} key={title}>
        <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
        >
            {title}&nbsp;{value || "---"}
        </Stack>
    </Grid>
}
const iconGen = (title: string, value: boolean, xs: number, sm: number) => {
    return <Grid item xs={xs} sm={sm} key={title}>
        <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
        >
            {title}&nbsp;
            {value === false ? <CloseIcon /> : <DoneIcon />}

        </Stack>
    </Grid>
}

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}
const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const AdminTempUserResgister = () => {

    const { adminStore, modalStore } = useStore();
    const { tempRegisterUserLoading, adminTempUsers, loadTempRegisterUser } = adminStore;
    const [pickupNo, setPickupNo] = useState<string | null>(null);

    const { openModal } = modalStore;

    const matches = useMediaQuery('(min-width:900px)');

    const handlePickupNoCollapse = (pNo: string) => {
        if (pickupNo === pNo) {
            setPickupNo(null);
        } else {
            setPickupNo(pNo);
        }
    };
    useEffectOnce(() => {
        loadTempRegisterUser();
    })

    return (
        <Box component='div' sx={{ mt: 20 }} >
            {adminTempUsers.length < 1 && !tempRegisterUserLoading &&
                <Typography variant='h4' textAlign='center' sx={{ mt: 5, color: '#072B02' }} >No records found</Typography>}
            {tempRegisterUserLoading && <SkeltonAnimation iteration={10} />}
            
            {/*Desktop View*/}
            {matches && !tempRegisterUserLoading && adminTempUsers.length > 0 &&
                <Box component="div">
                    <GenerateReportHeading heading='Pending Sign up' />
                    <Divider sx={{ height: 20 }} />
                    <TableContainer component={Paper} sx={koReportingContainerStyles.table}>
                        <Table aria-label="Partner table">
                            <TableHead key={'tableKey'}>
                                <TableRow sx={{ backgroundColor: '#fcfcfc' }}>
                                    <StyledTableCell>Date</StyledTableCell>
                                    <StyledTableCell>Name</StyledTableCell>
                                    <StyledTableCell>FullName</StyledTableCell>
                                    <StyledTableCell>Email</StyledTableCell>
                                    <StyledTableCell>Country</StyledTableCell>
                                    <StyledTableCell>Company</StyledTableCell>
                                    <StyledTableCell>City</StyledTableCell>
                                    <StyledTableCell>Street</StyledTableCell>
                                    <StyledTableCell>Zip</StyledTableCell>
                                    <StyledTableCell>VatNumber</StyledTableCell>
                                    <StyledTableCell>Roles</StyledTableCell>
                                    <StyledTableCell>Approved</StyledTableCell>
                                    <StyledTableCell>Blocked</StyledTableCell>
                                    <StyledTableCell>Action</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {adminTempUsers.map((tru: TempRegisterUser) =>
                                    <StyledTableRow
                                        key={tru.id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <StyledTableCell>
                                            {format(new Date(tru.createdDate), 'dd MMM yyyy')}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {tru.username}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {tru.fullName}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {tru.email}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {tru.countryName}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {tru.companyName}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {tru.city}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {tru.street}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {tru.zipCode}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {tru.vatNumber}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {tru.roles}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {tru.approved ? "YES" : "NO"}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {tru.blocked ? "YES" : "NO"}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <Button variant='text' onClick={() => openModal(<AdminTempUserActionModal tempUser={tru}
                                            />)}>
                                                Action
                                            </Button>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box>
                    </Box>
                </Box>
            }
            {/*Mobile view */}
            {!matches && !tempRegisterUserLoading && adminTempUsers.length > 0 &&

                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2} direction="column" justifyContent="center"
                        alignItems="center">
                        {adminTempUsers.map((tru: TempRegisterUser) => {
                            return (
                                <Grid item xs={12} key={tru.id}
                                    sx={{
                                        position: 'relative', pb: 0.5, pr: 0.5, mt: 2,
                                        bgcolor: '#000',
                                        borderRadius: '100% 0% 29% 71% / 0% 100% 0% 100% '
                                    }} >
                                    <Typography component='span' variant='body2'
                                        sx={{ position: 'absolute', right: 6, top: 0.1, color: '#fff' }}>
                                        Tier1Asset
                                    </Typography>
                                    <Card sx={mainStyles.cardStyles}>
                                        <CardHeader
                                            title={tru.fullName}
                                            subheader={format(new Date(tru.createdDate), 'dd-MM-yyyy')}
                                        />
                                        <CardContent>
                                            <Grid container direction='row' wrap='wrap' rowSpacing={1} columnSpacing={gridContainer}>
                                                {textGen('Username:', tru.username, 12, 6)}
                                                {textGen('Email:', tru.email, 12, 6)}
                                                {iconGen('Approved:', tru.approved, 12, 6)}
                                                {iconGen('Blocked:', tru.blocked, 12, 6)}
                                            </Grid>
                                        </CardContent>
                                        <CardActions disableSpacing>
                                            <ExpandMore
                                                expand={pickupNo === tru.id}
                                                onClick={() => handlePickupNoCollapse(tru.id)}
                                                aria-expanded={pickupNo === tru.id}
                                                aria-label="More info"
                                            >
                                                <ExpandMoreIcon />
                                            </ExpandMore>
                                        </CardActions>
                                        <Collapse in={pickupNo === tru.id} timeout="auto" unmountOnExit>
                                            <CardContent>
                                                <Grid container direction='row' wrap='wrap' rowSpacing={1} columnSpacing={gridContainer}>
                                                    {textGen('Company:', tru.companyName, 12, 6)}
                                                    {textGen('Country:', tru.countryName, 12, 6)}
                                                    {textGen('City:', tru.city, 12, 6)}
                                                    {textGen('Street:', tru.street, 12, 6)}
                                                    {textGen('Zip:', tru.zipCode, 12, 6)}
                                                    {textGen('Vat:', tru.vatNumber, 12, 6)}
                                                </Grid>
                                            </CardContent>
                                        </Collapse>
                                    </Card>
                                </Grid>
                            )
                        })}
                    </Grid>
                </Box>
            }
        </Box>
    )
}
const AdminTempUserResgisterPage = withNavbar(observer(AdminTempUserResgister));
export default AdminTempUserResgisterPage;